import { Dispatch, SetStateAction } from "react";
import { useIonModal } from "@ionic/react";
import { SchoolModel } from "model";

import { TimesTableArrayType } from "~components/RequestForm/hooks";

import { BulkEditTimes } from "./BulkEditTimes";

export type UseBulkEditProps = {
  school: SchoolModel;
  setIntervals: Dispatch<SetStateAction<TimesTableArrayType>>;
};

export const useBulkEdit = (props: UseBulkEditProps) => {
  const { school, setIntervals } = props;
  const [presentModal, dismissModal] = useIonModal(BulkEditTimes, {
    school,
    setIntervals,
    onDismiss: () => dismissModal(),
  });
  const openBulkEditsModal = () => {
    presentModal({});
  };

  return { openBulkEditsModal };
};
